import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


export interface AppVersionItem {
	code: string;
	number: number;
	date: string;
	patchNotes: { [lang: string]: string }[];
}
export interface AppVersionGlobal {
	current: AppVersionItem;
	history: AppVersionItem[];
}

@Injectable({
	providedIn: 'root'
})
export class AppVersionService {

	private url = 'assets/app-version.json';

	constructor(private http: HttpClient) {}

	getVersion(): Observable<AppVersionGlobal> {
		return this.http.get<AppVersionGlobal>(this.url);
	}
}